module.exports = __webpack_public_path__ + "static/img/1.e9f924c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/school/1.png
// module id = yxXP
// module chunks = 1